import {
  Box,
  Grid,
  Typography,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import React from "react";
import banner1 from "../assets/banner1.png";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import image1 from "../assets/courses1.png";
import image2 from "../assets/courses2.png";
import image3 from "../assets/courses3.png";
import image4 from "../assets/courses4.jpg";
import image5 from "../assets/courses5.jpg";
import image6 from "../assets/courses6.png";
import image7 from "../assets/courses7.png";
import image8 from "../assets/courses8.png";
import image9 from "../assets/courses9.png";
import { motion } from "framer-motion";
import CheckIcon from "@mui/icons-material/Check";
import Header from "./Header";
import Footer from "./Footer";

const courses = [
  {
    id: 1,
    image: image1,
    title: "Jyotish Praveena",
    description:
      "This is one year basic course on Indian Astrology (Jyotisha). This course lays the foundation of astrology with fundamental concepts and calculations.",
    duration: "1 Year",
    academics: "2 Semisters, 4 Papers",
    examination: "June & December - Every Year",
  },
  {
    id: 2,
    image: image2,
    title: "Jyotish Visharada",
    description:
      "This is one year advance course on Indian Astrology. This course beacons the complicated topics and other streams of astrology.",
    duration: "1 Year",
    academics: "2 Semisters, 6 Papers",
    examination: "June & December - Every Year",
  },
  {
    id: 3,
    image: image3,
    title: "Jyotish Bhushana",
    description:
      "This is equivalent to a Postgraduate research-oriented Thesis Programme. Aspirants should submit research paper under the guidance of a Guide.",
    duration: "2 Years",
    academics: "Original and authentic research",
    examination: "Evaluation of Thesis and Viva",
  },
  {
    id: 4,
    image: image4,
    title: "Jyotish Praveena",
    description:
      "This is one year basic course on Indian Astrology (Jyotisha). This course lays the foundation of astrology with fundamental concepts and calculations.",
    duration: "1 Year",
    academics: "2 Semisters, 4 Papers",
    examination: "June & December - Every Year",
  },
  {
    id: 5,
    image: image5,
    title: "Jyotish Visharada",
    description:
      "This is one year advance course on Indian Astrology. This course beacons the complicated topics and other streams of astrology.",
    duration: "1 Year",
    academics: "2 Semisters, 6 Papers",
    examination: "June & December - Every Year",
  },
  {
    id: 6,
    image: image6,
    title: "Jyotish Bhushana",
    description:
      "This is equivalent to a Postgraduate research-oriented Thesis Programme. Aspirants should submit research paper under the guidance of a Guide.",
    duration: "2 Years",
    academics: "Original and authentic research",
    examination: "Evaluation of Thesis and Viva",
  },
  {
    id: 7,
    image: image7,
    title: "Jyotish Praveena",
    description:
      "This is one year basic course on Indian Astrology (Jyotisha). This course lays the foundation of astrology with fundamental concepts and calculations.",
    duration: "1 Year",
    academics: "2 Semisters, 4 Papers",
    examination: "June & December - Every Year",
  },
  {
    id: 8,
    image: image8,
    title: "Jyotish Visharada",
    description:
      "This is one year advance course on Indian Astrology. This course beacons the complicated topics and other streams of astrology.",
    duration: "1 Year",
    academics: "2 Semisters, 6 Papers",
    examination: "June & December - Every Year",
  },
  {
    id: 9,
    image: image9,
    title: "Jyotish Bhushana",
    description:
      "This is equivalent to a Postgraduate research-oriented Thesis Programme. Aspirants should submit research paper under the guidance of a Guide.",
    duration: "2 Years",
    academics: "Original and authentic research",
    examination: "Evaluation of Thesis and Viva",
  },
];

const CoursesList = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <>
      <Header />
      <Box
        sx={{
          backgroundImage: `url(${banner1})`,
          backgroundPosition: "center",
          backgroundRepeat: "repeat",
        }}
      >
        <Grid
          container
          spacing={2}
          component={motion.div}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.2 }}
          sx={{
            p: { xs: 2, md: 8 },
            justifyContent: "center",
            alignItems: "center",
            mt: 10,
          }}
        >
          <Box sx={{ textAlign: "center", mb: 5, width: "100%" }}>
            <Typography sx={{ fontSize: 30, fontWeight: "bold", mb: 0 }}>
              Our Courses
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                maxWidth: 300,
                mx: "auto",
              }}
            >
              <Box sx={{ flex: 1, height: 2, bgcolor: "black" }} />
              <Box
                sx={{
                  px: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <AccountBalanceIcon sx={{ fontSize: 28, color: "#6d1675" }} />
              </Box>
              <Box sx={{ flex: 1, height: 2, bgcolor: "black" }} />
            </Box>
          </Box>

          {/* Course Cards */}
          {courses.map((course) => (
            <Grid
              component={motion.div}
              variants={itemVariants}
              size={{ xs: 12, sm: 6, md: 4 }}
              key={course.id}
              sx={{ p: 2 }}
            >
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: 3,
                  transition: "0.3s",
                  height: 650,
                  "&:hover": {
                    boxShadow: 6,
                  },
                  "&:hover .course-bg": {
                    backgroundColor: "#fff",
                  },
                  "&:hover .learn-btn": {
                    backgroundColor: "#ffc20f",
                    border: "1px solid #ffc20f",
                  },
                }}
              >
                <CardContent sx={{ textAlign: "center" }}>
                  <Typography
                    className="course-bg"
                    sx={{
                      fontSize: 25,
                      fontWeight: "bold",
                      color: "#6d1675",
                      mb: 2,
                      //   height: 50,
                      //   mt: -1,
                      transition: "0.3s",
                      ":hover": {
                        bgcolor: "#ffc20f",
                      },
                    }}
                  >
                    {course.title}
                  </Typography>
                  <Box sx={{ borderRadius: 5, mt: -2, overflow: "hidden" }}>
                    <motion.img
                      src={course.image}
                      alt={course.title}
                      style={{
                        objectFit: "cover",
                        borderRadius: 5,
                        width: "100%",
                        height: "auto",
                        marginBottom: 10,
                        // marginTop: 15,
                      }}
                      whileHover={{ scale: 1.1 }}
                      transition={{ duration: 0.3 }}
                    />
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{ mb: 2, color: "text.secondary", textAlign: "left" }}
                  >
                    {course.description}
                  </Typography>
                  <Typography variant="body2" sx={{ textAlign: "left" }}>
                    <CheckIcon sx={{ fontSize: 18, mr: 0.5, mt: 0.7 }} />
                    <b>Duration:</b> {course.duration}
                  </Typography>
                  <Typography variant="body2" sx={{ textAlign: "left" }}>
                    <CheckIcon sx={{ fontSize: 18, mr: 0.5 }} />
                    <b>Academics:</b> {course.academics}
                  </Typography>
                  <Typography variant="body2" sx={{ textAlign: "left" }}>
                    <CheckIcon sx={{ fontSize: 18, mr: 0.5 }} />
                    <b>Examination:</b> {course.examination}
                  </Typography>

                  <Button
                    className="learn-btn"
                    sx={{
                      mt: 2,
                      border: "2px solid #333",
                      textTransform: "none",
                      borderRadius: 2,
                      p: 1.5,
                      transition: "0.3s",
                      color: "black",
                      fontWeight: "bold",
                    }}
                  >
                    Learn More
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Footer />
    </>
  );
};

export default CoursesList;

